module.exports = __webpack_public_path__ + "static/9-46e200ae37524f100791e15c90a99b80.png";